import Vue from 'vue'
import Router from 'vue-router'


import home from '@/pages/home.vue'
import download from '@/pages/download.vue'
import doc from '@/pages/document.vue'
import privacyPolicy from '@/components/privacyPolicy.vue'
import xtgx from '@/pages/xtgx.vue'

Vue.use(Router)
  
export default new Router({
  mode: 'history',
  routes: [
    { path: '/home', component: home },
    { path: '/download', component: download }, 
    { 
      path: '/doc', 
      component: doc,
      redirect: {name:'privacy'},
      children: [
        {
          path: '/privacy',
          name: 'privacy',
          component: privacyPolicy
        }
      ]
    },
    {
      path: '/xtgx',
      name: 'xtgx',
      component: xtgx
    }, 
    { path: '/', redirect: '/home' },
    { path: '*', redirect: '/404'},
    { 
      path: '/404',
      component: () => import('@/components/error.vue')
    }
  ]
})  